/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_NameInputs */

const vi_fertilizer_name = /** @type {(inputs: Fertilizer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên phân bón`)
};

/**

* @param {Fertilizer_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_name = /** @type {((inputs?: Fertilizer_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_name(inputs)
});